import classNames from "classnames";
import type React from "react";
import type { ReactElement } from "react";
import { Flex } from "../Flex";
import "./ModalOverlay.css";
import Button from "../Buttons";
import Icon from "../Icon";
import Label from "../Label";

type BaseProps = {
    className?: string;
    containerClassName?: string;
    children: React.ReactNode;
};

type ModalOverlayProps = {
    title:
        | string
        | ReactElement<
              React.DetailedHTMLProps<
                  React.HTMLAttributes<HTMLSpanElement>,
                  HTMLSpanElement
              >
          >;
    onClose?: () => void;
} & BaseProps;

function ModalOverlay(props: ModalOverlayProps) {
    const { className, containerClassName, children, title, onClose } = props;

    return (
        <div className={classNames("modal-overlay", className)}>
            <Flex.Column
                className={classNames("modal-overlay__container", containerClassName)}
            >
                <Flex.Row
                    className="modal-overlay__header"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Label.Medium.SemiBold>{title}</Label.Medium.SemiBold>

                    {onClose && (
                        <Button.Ghost
                            onClick={() => {
                                onClose();
                            }}
                            className="modal-overlay__close"
                        >
                            <Icon.Close.Medium.N10 />
                        </Button.Ghost>
                    )}
                </Flex.Row>
                <Flex.Column className="modal-overlay__content">{children}</Flex.Column>
            </Flex.Column>
        </div>
    );
}

function ModalOverlayContent(props: BaseProps & { padding?: "medium" | undefined }) {
    const { className, children, padding } = props;
    return (
        <Flex.Column
            className={classNames(
                "modal-overlay__content",
                { [`modal-overlay__content--padding-${padding}`]: !!padding },
                className,
            )}
        >
            {children}
        </Flex.Column>
    );
}

function ModalOverlayFooter(props: BaseProps) {
    const { className, children } = props;
    return (
        <Flex.Column className={classNames("modal-overlay__footer", className)}>
            {children}
        </Flex.Column>
    );
}

export default {
    Base: ModalOverlay,
    Content: ModalOverlayContent,
    Footer: ModalOverlayFooter,
};
